import config from 'config'
const { SCHEME: scheme, PACKAGE_NAME: packageName } = config.APP_INFO

export const openLinkBlank = (url) => {
  let link = document.createElement('a')
  let evt = document.createEvent('HTMLEvents')
  evt.initEvent('click', false, false)
  link.href = url
  link.target = '_blank'
  link.style.display = 'none'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  link = null
  evt = null
}

const openApp = (link) => {
  const CallApp = require('callapp-lib')
  const options = {
    scheme: {
      protocol: scheme,
      host: 'coupon',
    },
    intent: {
      package: packageName,
      scheme: scheme,
    },
    // apple store
    appstore:
      'https://apps.apple.com/us/app/香港01-新聞資訊及生活服務/id1084662006',
    // googleplay
    yingyongbao:
      'https://play.google.com/store/apps/details?id=com.hk01.news_app',
    fallback:
      'https://faq.hk01.com/hc/zh-tw/articles/360033689514-如何下載香港01流動應用程式-App-', // 唤端失败后跳转的地址
  }

  if (typeof window !== 'undefined' && typeof navigator !== 'undefined') {
    const callLib = new CallApp(options)
    callLib.open({
      path: link || 'home/skus',
    })
  }
}
export default openApp
